<template>
  <ElDialog
    :visible.sync="visible"
    width="809px"
    custom-class="el-dialog-clearstyle-class"
    append-to-body
    @open="onOpen"
  >
    <div class="role-switch">
      <div class="close" @click="visible = false"></div>
      <div class="container">
        <div class="toolbar">
          <ElSelect
            v-model="step"
            class="custom-select-class"
            placeholder="阶段"
            clearable
            collapse-tags
            multiple
            @change="onFilterList"
          >
            <ElOption v-for="option in stepOptions" :key="option.id" :value="option.name" :label="option.name">
              <div class="option">
                <img class="option-icon" :src="option.icon" />
                <span class="option-txt">{{ option.name }}</span>
              </div>
            </ElOption>
          </ElSelect>
          <ElSelect
            v-model="weapon"
            class="custom-select-class"
            placeholder="武器"
            clearable
            collapse-tags
            multiple
            @change="onFilterList"
          >
            <ElOption v-for="option in weaponOptions" :key="option.id" :value="option.name" :label="option.name">
              <div class="option">
                <img class="option-icon" :src="option.icon" />
                <span class="option-txt">{{ option.name }}</span>
              </div>
            </ElOption>
          </ElSelect>
          <ElInput
            v-model.trim="searchKey"
            style="width: 270px; margin-left: auto;"
            prefix-icon="el-icon-search"
            placeholder="输入妮姬名称"
            @input="onFilterList"
          ></ElInput>
        </div>
        <ElScrollbar style="flex-grow: 1; height: 0;" wrapStyle="height: 100%; overflow-x: hidden;">
          <div v-if="filtList.length" class="grid-list">
            <div v-for="item in filtList" :key="item.content_id" :data-id="item.content_id" class="grid-item">
              <a :href="`/${alias}/tj/${item.content_id}.html`">
                <div class="icon-wrapper">
                  <img class="icon" :src="item.icon_1 || item.icon" :alt="item.name" />
                </div>
                <div class="name" :style="{ color: item.content_id == current ? '#3F3F3F' : '#3490e6' }">
                  {{ item.name }}
                </div>
              </a>
            </div>
          </div>
          <div v-else class="empty">
            <img src="@/assets/nikke_imgs/conversation-no-data.png" />
            <span>无数据</span>
          </div>
        </ElScrollbar>
      </div>
    </div>
  </ElDialog>
</template>
<script>
import { apiWikiTjList } from "@/api/wikiApi";

export default {
  name: "RoleSwitch",
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      /** 阶段 */
      step: [],
      /** 武器 */
      weapon: [],
      searchKey: "",
      tjList: [],
      filtList: [],
      stepOptions: [
        {
          id: 84,
          name: "一阶",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_89/h_102/1253/236746/2023/7/18/490415.png"
        },
        {
          id: 85,
          name: "二阶",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_89/h_102/1253/236746/2023/7/18/355666.png"
        },
        {
          id: 86,
          name: "三阶",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_89/h_102/1253/236746/2023/7/18/358196.png"
        },
        {
          id: 3719,
          name: "通用",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_89/h_102/1253/4408/2023/10/6/560567.png"
        }
      ],
      weaponOptions: [
        {
          id: 98,
          name: "步枪",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/465089.png"
        },
        {
          id: 99,
          name: "冲锋枪",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/727862.png"
        },
        {
          id: 101,
          name: "霰弹枪",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/568227.png"
        },
        {
          id: 102,
          name: "狙击步枪",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/203084.png"
        },
        {
          id: 103,
          name: "发射器",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/819673.png"
        },
        {
          id: 104,
          name: "机枪",
          icon: "//cdnimg.gamekee.com/wiki2.0/images/w_267/h_291/1253/236746/2023/7/18/929010.png"
        }
      ]
    };
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(bool) {
        this.$emit("input", bool);
      }
    },
    current() {
      return this.$route.params.id;
    }
  },
  watch: {
    step(value) {
      console.log(value);
    }
  },
  methods: {
    async fetchTjList() {
      const alias = this.alias;
      const { code, data } = await apiWikiTjList();
      if (code === 0) {
        this.tjList = Object.freeze(
          data
            .map(item => item[alias])
            .sort((a, b) => {
              return Number(b.name_code || 0) - Number(a.name_code || 0);
            })
        );
        this.filtList = Object.freeze(
          data
            .map(item => item[alias])
            .sort((a, b) => {
              return Number(b.name_code || 0) - Number(a.name_code || 0);
            })
        );
      }
    },
    onOpen() {
      this.fetchTjList();
    },
    onFilterList() {
      this.filtList = this.tjList
        .filter(obj => {
          const nameMatch = this.searchKey === "" || obj.name.toLowerCase().includes(this.searchKey.toLowerCase());
          const levelMatch = this.step.length === 0 || this.step.some(l => obj.jd.includes(l));
          const weaponMatch = this.weapon.length === 0 || this.weapon.some(w => obj.wq.includes(w));
          return nameMatch && levelMatch && weaponMatch;
        })
        .sort((a, b) => {
          return Number(b.name_code || 0) - Number(a.name_code || 0);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.role-switch {
  position: relative;
  width: 809px;
  height: 610px;
  background: url("~@/assets/nikke_imgs/switch-header.png") top center / contain no-repeat,
    url("~@/assets/nikke_imgs/switch-body.png") top 40px center / 801px 555px no-repeat;
  padding-top: 42px;
  .close {
    position: absolute;
    right: 28px;
    top: 12px;
    width: 18px;
    height: 18px;
    background: url("~@/assets/nikke_imgs/switch-close.png") center / contain no-repeat;
    cursor: pointer;
  }
  .container {
    display: flex;
    flex-direction: column;
    width: 760px;
    height: 510px;
    margin: 16px auto 0;
    row-gap: 16px;
    .toolbar {
      display: flex;
      column-gap: 12px;
    }
    .grid-list {
      display: grid;
      grid-template-columns: repeat(8, 82px);
      justify-content: space-between;
      row-gap: 22px;
      .grid-item {
        .icon-wrapper {
          position: relative;
          width: 82px;
          height: 120px;
          background: url("~@/assets/nikke_imgs/switch-grid-item-bg.png") top left / cover no-repeat;
          .icon {
            position: absolute;
            right: 3px;
            bottom: 2px;
            width: 74px;
            height: 109px;
            object-fit: cover;
            object-position: center top;
            display: block;
          }
        }
        .name {
          font-size: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: fit-content;
          max-width: 100%;
          margin: 8px auto 0;
        }
      }
    }
    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 8px;
      width: fit-content;
      margin: 80px auto 0;
    }
  }
}
.option {
  display: flex;
  align-items: center;
  column-gap: 8px;
  .option-icon {
    width: 21px;
    height: 24px;
    object-fit: contain;
  }
  .option-txt {
    color: #000000;
    font-size: 15px;
  }
}
/* 选择器 */
/deep/ .custom-select-class {
  width: 160px;
}
/deep/ .el-input__inner:focus {
  border-color: #3490e6;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #3490e6;
}
</style>
